import React from 'react';
import { useDispatch } from 'react-redux';

import type { Dispatch } from '@swf/core/store';

import NextButton from '../NextButton/NextButton';

import styles from './PINReset.scss';
import PINResetContent from './PINResetContent/PINResetContent';

const PINReset: React.FC = () => {
  const {
    modal: { close }
  } = useDispatch<Dispatch>();

  return (
    <>
      <PINResetContent />
      <NextButton className={styles.next} block onClick={() => close()} />
    </>
  );
};

export default PINReset;
